import React from 'react';
const UserAvatar = ({ images }) => {
    return (
        <>
            {images.main && (
                <img
                    src={images.main}
                    alt="main"
                    className="w-75 img-fluid img-thumbnail rounded mx-auto d-block mb-3 border border-dark shadow-lg bg-white rounded"
                    style={{ padding: "0", boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px" }}
                />
            )}
            {images.first && (
                <img
                    src={images.first}
                    alt="First"
                    className="w-75 img-fluid img-thumbnail rounded mx-auto d-block mb-3 border border-dark shadow-lg bg-white rounded"
                    style={{ padding: "0", boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px" }}
                />
            )}
            {images.second && (
                <img
                    src={images.second}
                    alt="second"
                    className="w-75 img-fluid img-thumbnail rounded mx-auto d-block mb-3 border border-dark shadow-lg bg-white rounded"
                    style={{ padding: "0", boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px" }}
                />
            )}
        </>
    );
};

export default UserAvatar;
